import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  deleteSavedDraft,
} from "@/api/program-steps";

/**
 * DELETE /saved-draft/{program_id}
 * Delete a saved draft
 */
export const useDeleteSavedDraft = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (programId: string) => deleteSavedDraft(programId),
    onSuccess: () => {
      // Invalidate the roles query to refresh the list
      queryClient.invalidateQueries({ queryKey: ["programs-drafts"] });
    },
  });
}; 